import React from 'react';
import image01 from '../../../assets/images/technology/technology-graph-01.svg';
import image02 from '../../../assets/images/technology/technology-graph-02.svg';
import image03 from '../../../assets/images/technology/technology-graph-03.svg';
import image04 from '../../../assets/images/technology/technology-graph-04.svg';
import image05 from '../../../assets/images/technology/technology-graph-05.svg';
import image06 from '../../../assets/images/technology/technology-graph-06.svg';

export const graphStatic = [
  {
    image: {
      src: image01,
      alt: 'Source of pollutants - Mila stats',
      width: 604,
      height: 375,
      caption: 'Add caption here ...',
    },
    title: 'Source of pollutants',
    description: () => (
      <p>
        Get a complete view of the quantity and sources of pollutants in your
        home.
      </p>
    ),
  },
  {
    image: {
      src: image02,
      alt: 'Tells you your exposure risk - Mila stats',
      width: 604,
      height: 379,
      caption: 'Add caption here ...',
    },
    title: 'Tells you your exposure risk',
    description: () => (
      <p>Get a read on what’s putting your air—and your health—at risk.</p>
    ),
  },
  {
    image: {
      src: image03,
      alt: 'Monitor outdoor air quality - Mila stats',
      width: 604,
      height: 379,
      caption: 'Add caption here ...',
    },
    title: 'Monitor outdoor air quality',
    description: () => (
      <p>Stay a step ahead of what’s blowing in from outside.</p>
    ),
  },
  {
    image: {
      src: image04,
      alt: 'Mila’s health impact - Mila stats',
      width: 576,
      height: 373,
      caption: 'You had 14 days when the AQI went over 50. That’s icky.',
    },
    title: 'Mila’s health impact',
    description: () => (
      <p>Track the difference Mila makes — for your air and your health.</p>
    ),
  },
  {
    image: {
      src: image05,
      alt: 'See daily trends - Mila stats',
      width: 576,
      height: 333,
      caption: 'Add caption here ...',
    },
    title: 'See daily trends',
    description: () => (
      <p>
        Track how your air shifts throughout the day, from morning to midnight.
      </p>
    ),
  },
  {
    image: {
      src: image06,
      alt: 'Compare your air - Mila stats',

      width: 577,
      height: 327,
      caption: 'Add caption here ...',
    },
    title: 'Compare your air',

    description: () => (
      <p>See how your air stacks up against other Mila homes.</p>
    ),
  },
];
